export default __webpack_public_path__ + "static/media/default_cover.d71364ec.jpg";